module.exports = __webpack_public_path__ + "media/assets/images/maple/slider2-d8dc3f14b1f16a00128090a55a09f41a.jpg";